import { DisbursementEnhanced } from '@percent/admin-dashboard/api/actions/disbursements/disbursements.types'

export type RemoveFromBatchModalProps = {
  isOpen: boolean
  onClose: () => void
  disbursement: DisbursementEnhanced
  refreshData: (() => void) | null
}

export enum RemoveFromBatchStatus {
  SUCCESS = 'success',
  ERROR = 'error'
}
